module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/banners/referral-bg-ddfd9e47d8ce984fe75413d7b642441e.svg";